import { gql } from "@apollo/client";

export const updateLensSources = gql`
    mutation updateLensSources($lensSourceUpdates: [InputLenssourceLensSourceUpdate]!, $organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        updateLensSources(input: { lensSourceUpdates: $lensSourceUpdates, organizationId: $organizationId }) {
            lensSourceList {
                id
            }
        }
    }
`;
